export const GET_ALL_ROLES_SAGAS = 'GETALLROLESSAGAS';
export const GET_PAGES_SAGAS = 'GETPAGESSAGAS';
export const GET_WORKFLOW_ACTIONS_SAGAS = 'GETWORKFLOWACTIONSSAGAS';
export const CREATE_ROLE_ACTIONS_SAGAS = 'CREATEROLEACTIONSSAGAS';
export const EDIT_ROLE_ACTIONS_SAGAS = 'EDITROLEACTIONSSAGAS';
export const DELETE_ROLE_ACTIONS_SAGAS = 'DELETEROLEACTIONSSAGAS';
export const GET_PAGE_ROLES_SAGAS = 'GET_PAGE_ROLES_SAGAS';
